import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import { userActions } from "_store/actions";

export function ResetPasswordSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(userActions.resetPasswordSuccessModalClose());
    navigate("/login");
  };

  return (
    <Modal centered show onHide={handleConfirm} size="md">
      <Modal.Header style={{ border: 0 }} />
      <Modal.Body>Thank you, please check your email for a password reset code</Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleConfirm}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
